const loadedHomeImageUrls = new Set<string>();

export function markHomeImageLoaded(url: string): void {
  if (url) loadedHomeImageUrls.add(url);
}

export function isHomeImageLoaded(url: string): boolean {
  return Boolean(url && loadedHomeImageUrls.has(url));
}
